import { render } from "./RelayList.vue?vue&type=template&id=4c8fd540"
import script from "./RelayList.vue?vue&type=script&lang=js"
export * from "./RelayList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__